module.exports = __webpack_public_path__ + "static/media/tTextIcon.c1008089.svg";